import type { Cart } from "@repo/core/cart";
import type { QueryClient } from "@tanstack/react-query";

import { cartKeys } from "./keys";

export function setCartQueryData(
  queryClient: QueryClient,
  locale: string,
  cart: Cart | null,
) {
  queryClient.setQueryData(cartKeys.cart(locale), cart);
}

export async function cancelCartQuery(queryClient: QueryClient) {
  await queryClient.cancelQueries({ queryKey: cartKeys.all });
}

export function syncCartQueries(queryClient: QueryClient) {
  void queryClient.invalidateQueries({ queryKey: cartKeys.all });
  void queryClient.invalidateQueries({ queryKey: cartKeys.checkout });
  void queryClient.invalidateQueries({ queryKey: cartKeys.checkoutDelivery });
}
